import { datadogRum } from "@datadog/browser-rum"
import { reactPlugin } from '@datadog/browser-rum-react';
import packageJson from '../../package.json';

const appVersion = packageJson.version;

export function initializeDatadogRum() {
	datadogRum.init({
		applicationId: process.env.REACT_APP_DD_APP_ID,
		clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
		site: "datadoghq.com",
		service: "client-acquisition",
		env: process.env.DD_ENV || 'development',
		version: appVersion || '0.0.0',
		sessionSampleRate: 100,
		sessionReplaySampleRate: 20,
		trackUserInteractions: true,
		trackResources: true,
		trackLongTasks: true,
		trackViewsManually: false,
		defaultPrivacyLevel: "mask-user-input",
		allowedTrackingOrigins: [
			"https://*.purplewave.com",
			"https://*.cliquidator.info",
		],
		traceSampleRate: 100,
		trackingConsent: "granted",
		plugins: [reactPlugin({ router: true })],
	})
}
